import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AssetsRoutingModule } from './assets-routing.module';
import { AddComponent } from './add/add.component';
import { ListComponent } from './list/list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { QuillModule } from 'ngx-quill';
import { ViewComponent } from './view/view.component';
import { MatMenuModule } from '@angular/material/menu';
import { NewReportComponent } from './new-report/new-report.component';


@NgModule({
  declarations: [
    AddComponent,
    ListComponent,
    ViewComponent,
    NewReportComponent
  ],
  imports: [
    CommonModule,
    AssetsRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    PipeModule,
    NgbModule,
    NgSelectModule,
    NgxSpinnerModule,
    QuillModule.forRoot(),
    MatMenuModule
  ]
})
export class AssetsModule { }
